export enum UserStatusEnum {
  active = 'active',
  inActive = 'inActive',
  pending = 'pending',
}
